import { useEffect } from 'react';

const DEFAULT_TITLE = 'CherryPKD — Rent it. Bid on it. Buy it.';
const DEFAULT_DESC  = 'The peer-to-peer rental, auction, and sales marketplace built on trust.';
const BASE_URL      = 'https://www.cherrypkd.com';

function setMeta(property, content) {
  let el = document.querySelector(`meta[property="${property}"]`) ||
           document.querySelector(`meta[name="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    if (property.startsWith('og:') || property.startsWith('twitter:')) {
      el.setAttribute('property', property);
    } else {
      el.setAttribute('name', property);
    }
    document.head.appendChild(el);
  }
  el.setAttribute('content', content || '');
}

const isStaging = typeof window !== 'undefined' && (
  window.location.hostname.includes('staging') ||
  window.location.hostname.includes('railway.app') ||
  window.location.hostname === 'localhost'
);

export function useSEO({ title, description, image, url, type = 'website' } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} — CherryPKD` : DEFAULT_TITLE;
    const desc      = description || DEFAULT_DESC;
    const pageUrl   = url ? `${BASE_URL}${url}` : BASE_URL;

    document.title = fullTitle;
    setMeta('description',       desc);
    setMeta('og:title',          fullTitle);
    setMeta('og:description',    desc);
    setMeta('og:type',           type);
    setMeta('og:url',            pageUrl);
    if (image) setMeta('og:image', image);
    setMeta('twitter:card',      'summary_large_image');
    setMeta('twitter:title',     fullTitle);
    setMeta('twitter:description', desc);
    if (image) setMeta('twitter:image', image);
    if (isStaging) setMeta('robots', 'noindex, nofollow');

    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title, description, image, url, type]);
}

export function useJsonLd(data) {
  useEffect(() => {
    if (!data) return;
    const id = 'cherrypkd-jsonld';
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
    };
  }, [data]);
}
